module.exports = __webpack_public_path__ + "img/1.345b62b1.png";